import React from 'react';
import PropTypes from 'prop-types';
import WpBlogPageTemplate from '../WpBlogPageTemplate';
import { graphql } from 'gatsby';

const PaginatedWpPodcastTemplate = ({ data, pageContext }) => {
  const posts = data.allWpPodcast.nodes;
  console.log('Podcast Page Context', pageContext.latestBlogposts);

  return (
    <WpBlogPageTemplate
      metaTitle={`Blog | Oasis living - property blog tags | ${pageContext.pageNumber}`}
      metaDescription={`Listen to our podcast and get helpful advice from property market experts. We invite guests on to give advice for everyday landlords. Start listening now | ${pageContext.pageNumber}`}
      heroTitle={'Podcast'}
      heroSubTitle={
        'Get useful and insightful knowledge from some of the industry’s leading experts by listening to our podcast. We’ll explore all areas of letting property from buy-to-let, build-to-rent, HMOs and more. You can listen on the website here or Spotify, Amazon Music and more!'
      }
      blogPosts={posts}
      currentPage={pageContext.pageNumber}
      totalPosts={pageContext.totalPosts}
      isPodcasts={true}
      paginationBasePath="/podcast"
      latestBlogposts={pageContext.latestBlogposts}
      latestPodcasts={pageContext.latestPodcasts}
      specialEventPost={pageContext.specialEventPost}
      featuredPodcast={pageContext.featuredPodcast}
    />
  );
};

PaginatedWpPodcastTemplate.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
};

export default PaginatedWpPodcastTemplate;

export const pageQuery = graphql`
  query($limit: Int!, $skip: Int!) {
    allWpPodcast(
      limit: $limit
      sort: { order: DESC, fields: date }
      skip: $skip
    ) {
      nodes {
        seo {
          readingTime
          metaDesc
        }
        categories {
          nodes {
            name
            slug
          }
        }
        title
        date(formatString: "MMM DD, YYYY")
        slug
        featuredImage {
          node {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, width: 450)
              }
            }
          }
        }
      }
    }
  }
`;
